export default __webpack_public_path__ + "static/media/signup.dc9fa5cf.png";